import { action, thunk } from 'easy-peasy';
import { getDomains, reserveDomain, releaseDomain } from '../services/LinkolnDomains';

const LinkolnDomainsModel = {
  domains: [],
  domain_result: "",
  showDomains: action((state, new_domains) => {
    state.domains = new_domains;
  }),
  getDomains: thunk(async (actions) => {
    let domains = await getDomains();
    actions.showDomains(domains);
  }),
  reserveDomain: thunk(async (_, payload) => {
    let result = await reserveDomain(payload.domain, payload.subdomain);
    return result.status;
  }),
  releaseDomain: thunk(async (_, {domain, subdomain}) => {
     await releaseDomain(domain, subdomain);
  })
};

export default LinkolnDomainsModel;
